export default __webpack_public_path__ + "static/media/ig-icon.dd517533.svg";